import React from 'react';
import Component from '@plone/volto/components/theme/Component/Component';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import { useSelector } from 'react-redux';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { FormattedMessage, useIntl } from 'react-intl';
import { messages as personMessages } from '../../../components/Person/PersonMetadata';
import Obfuscate from 'react-obfuscate';

const CustomPersonListingItemTemplate = ({ item, isEditMode }) => {
  const intl = useIntl();
  const taxo_classification = useSelector(
    (state) => state.taxonomies?.['collective.taxonomy.classification'],
  );
  const taxo_membership = useSelector(
    (state) => state.taxonomies?.['collective.taxonomy.membership_type'],
  );
  // const taxo_employment = useSelector(
  //   (state) => state.taxonomies?.['collective.taxonomy.employment_type'],
  // );
  const taxo_persontype = useSelector(
    (state) => state.taxonomies?.['collective.taxonomy.person_type'],
  );
  const taxo_projecttype = useSelector(
    (state) => state.taxonomies?.['collective.taxonomy.project_type'],
  );

  const related_projectypes = taxo_projecttype?.data?.tree?.map((t) => t.key);

  const language = useSelector((state) => state.intl.locale);

  const getTaxonomyTitle = (token, taxonomy) => {
    if (taxonomy && taxonomy.data?.tree) {
      const term = taxonomy.data.tree.find((term) => term.key === token);
      return term ? term.translations?.[language] ?? term.title : token;
    }
  };

  const nametitle = item.title.split(',')[0];
  const titletitle = item.title.split(',')[1];
  const groupedProjects = (item.getProjectList || []).reduce(
    (groups, project) => {
      const types = project.type.filter((x) =>
        new Set(related_projectypes || []).has(x),
      );
      for (const type of types) {
        if (!groups[type]) {
          groups[type] = [];
        }
        groups[type].push(project);
      }
      return groups;
    },
    {},
  );

  return (
    <>
      <div className="listing-body">
        <h3 className="title">
          {nametitle}
          {titletitle && <span>, {titletitle}</span>}
        </h3>

        {(item?.taxonomy_classification || item?.taxonomy_membership_type) && (
          <div className="classification">
            {[
              ...(item?.taxonomy_classification || []).map((token) =>
                getTaxonomyTitle(token, taxo_classification),
              ),
              ...(item?.taxonomy_membership_type || []).map((token) =>
                getTaxonomyTitle(token, taxo_membership),
              ),
            ]
              .filter(Boolean)
              .join(', ')}
          </div>
        )}

        {(item?.taxonomy_person_type || []).includes('lil4fud2pa') && (
          <div className="external">
            {getTaxonomyTitle('lil4fud2pa', taxo_persontype)}
          </div>
        )}

        {item?.employment && (
          <div className="employment-type">{item.employment.join(', ')}</div>
        )}

        {Object.keys(groupedProjects).length > 0 && (
          <div className="projects">
            {Object.keys(groupedProjects)
              .sort(
                (a, b) =>
                  related_projectypes.indexOf(a) -
                  related_projectypes.indexOf(b),
              )
              .map((groupKey, idx) => (
                <div key={idx} className="project-group">
                  <strong>
                    {intl.formatMessage(personMessages[groupKey], {
                      count: groupedProjects[groupKey].length,
                    }) + ':'}
                  </strong>

                  {groupedProjects[groupKey]
                    .sort((a, b) => a.title.localeCompare(b.title)) // sort projects alphabetically
                    .map((project, index) => (
                      <span key={index}>
                        <ConditionalLink
                          to={flattenToAppURL(project.url)}
                          condition={!isEditMode}
                        >
                          {project.title}
                        </ConditionalLink>
                      </span>
                    ))}
                </div>
              ))}
          </div>
        )}

        <div className="line-wrapper">
          {(item?.getEmail || item?.getPhoneNumber) && (
            // contact oneliner by desktop
            <div className="contact">
              {item?.getPhoneNumber && (
                <span className="telefon"> {item.getPhoneNumber}</span>
              )}

              {item?.getEmail && (
                <Obfuscate email={item.getEmail}></Obfuscate>
                // <a href={`mailto:${item.getEmail}`}>{item.getEmail}</a>
              )}
            </div>
          )}
        </div>
        <ConditionalLink
          item={item}
          condition={!isEditMode}
          className="listing-readmore"
          title={intl.formatMessage(
            personMessages['listing.readmore.profileOf'],
            { name: nametitle },
          )}
        >
          <FormattedMessage
            id="listing.readmore.profile"
            defaultMessage="to profile"
          />
        </ConditionalLink>
      </div>
      <Component
        componentName="PreviewImage"
        item={item}
        alt={item?.image_alternative_text ?? 'Portraitbild einer Person'}
      />
    </>
  );
};

export default CustomPersonListingItemTemplate;
